import { css } from '@emotion/react';
import { Theme } from '../../config/theme';

export default (theme: Theme) => ({
  container: css`
    display: flex;
    justify-content: flex-start;
    gap: 20px;
    width: 100%;
  `,
  input: css`
    position: relative;
    margin-bottom: 12px;
    min-width: 150px;
  `,
  fullInput: css`
    position: relative;
    max-width: 320px;
  `,
  button: css`
    border: none;
    font-size: ${theme.fontSizes.small};
    min-width: 201px;
    height: 48px;
    letter-spacing: 0.1em;
    line-height: 1.81em;
    color: ${theme.color.secondary};
    background: ${theme.color.button};
    margin-top: ${theme.spacing.large};
    margin-bottom: ${theme.spacing.large};

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
    &:hover {
      filter: brightness(0.8);
    }

    @media (max-width: 30em) {
      width: 100%;
    }
  `,
});
